export default __webpack_public_path__ + "static/media/page404.ed6d95ca.png";